import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import { queryClient } from './services/query-client';
import './styles/globals.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

const root = createRoot(container);

root.render(
	<StrictMode>
		<GoogleOAuthProvider clientId={process.env.GOOGLE_CLIENT_ID || ''}>
			<QueryClientProvider client={queryClient}>
				<App />
			</QueryClientProvider>
		</GoogleOAuthProvider>
	</StrictMode>
);
